import { c as _c } from "react/compiler-runtime";
import { add, isSameDay } from 'date-fns';
import { Form, Formik, type FormikProps } from 'formik';
import { useParams, useSearchParams } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { buildRequestSource } from 'utils';
import { formatDashedYYYYMMDD, getTripLengthInDays, parseDate } from 'utils/DateFormats';
import * as Yup from 'yup';
import { getDefaultOriginId } from '~/constants/default-origin';
import { TRPC_SETTINGS } from '~/constants/trpc';
import useFeaturedActivities from '~/hooks/useFeaturedActivities';
import useJourneyData from '~/hooks/useJourneyData';
import { useRouter } from '~/i18n/navigation';
import { api } from '~/libs/api';
import { useJourneyActions } from '~/stores/journeyStore';
import { getFirstLegOriginId, isUSOrigin } from '~/utils/blueprintHelpers/isUSTrip';
import { ensureFutureDate } from '~/utils/dateHelpers/dateHelpers';
import { minNumberRooms } from '~/utils/paxHelpers';
const JourneyEditForm = t0 => {
  const $ = _c(74);
  const {
    isPopulated: t1,
    isTemplateTrip: t2,
    children
  } = t0;
  const isPopulated = t1 === undefined ? true : t1;
  const isTemplateTrip = t2 === undefined ? false : t2;
  const {
    user,
    uniqueId,
    details,
    items,
    region: regionData
  } = useJourneyData();
  const {
    setFormRef,
    setIsCheckingAvailability
  } = useJourneyActions();
  const t = useTranslations("journey");
  const locale = useLocale();
  const formRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...TRPC_SETTINGS.QUERY_NO_REFETCH
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    data: origins
  } = api.cms.origins.useQuery(undefined, t3);
  let firstLegOriginId;
  let t4;
  if ($[1] !== items || $[2] !== origins) {
    firstLegOriginId = getFirstLegOriginId(items);
    t4 = isUSOrigin({
      origins: origins ?? [],
      originId: firstLegOriginId
    });
    $[1] = items;
    $[2] = origins;
    $[3] = firstLegOriginId;
    $[4] = t4;
  } else {
    firstLegOriginId = $[3];
    t4 = $[4];
  }
  const isUS = t4;
  const {
    startDate,
    endDate
  } = details;
  const minDurationDays = regionData.minDurationDays ?? details.tripInDays;
  const maxDurationDays = regionData.maxDurationDays ?? details.tripInDays;
  const {
    adult_count,
    childAges,
    room_count,
    isOneWayTrip,
    twinRoomPreferred,
    duration: jfDuration,
    requestSource
  } = user;
  const closest_city = items[0]?.type === "Journey" ? items[0]?.origin : items[0]?.title ?? "Unknown";
  const router = useRouter();
  useParams();
  const searchParams = useSearchParams();
  let t5;
  if ($[5] !== searchParams) {
    t5 = searchParams?.get("region");
    $[5] = searchParams;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const region = t5;
  const featuredActivities = useFeaturedActivities();
  const [isTouched, setIsTouched] = useState(false);
  const isTwinPreferred = twinRoomPreferred === true || twinRoomPreferred === "yes";
  let effectiveEndDate;
  let effectiveStartDate;
  let startDateAsDate;
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== adult_count || $[8] !== childAges || $[9] !== closest_city || $[10] !== endDate || $[11] !== isPopulated || $[12] !== isTemplateTrip || $[13] !== jfDuration || $[14] !== room_count || $[15] !== startDate) {
    startDateAsDate = parseDate(startDate);
    const endDateAsDate = parseDate(endDate);
    let t12;
    if ($[25] !== childAges) {
      t12 = childAges ? childAges.map(String) : [];
      $[25] = childAges;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    const childAgesAsStrings = t12;
    effectiveStartDate = isPopulated ? ensureFutureDate(startDateAsDate) : null;
    effectiveEndDate = isPopulated && effectiveStartDate ? add(effectiveStartDate, {
      days: getTripLengthInDays(startDateAsDate, endDateAsDate) - 1
    }) : isPopulated ? endDateAsDate : null;
    t6 = isPopulated ? adult_count : 2;
    t7 = isPopulated ? childAges.length : 0;
    if ($[27] !== childAgesAsStrings || $[28] !== isPopulated) {
      t8 = isPopulated ? childAgesAsStrings : [];
      $[27] = childAgesAsStrings;
      $[28] = isPopulated;
      $[29] = t8;
    } else {
      t8 = $[29];
    }
    t9 = isPopulated ? room_count : 1;
    t10 = isPopulated || isTemplateTrip ? closest_city : "";
    t11 = isTemplateTrip ? jfDuration : effectiveStartDate && effectiveEndDate ? getTripLengthInDays(effectiveStartDate, effectiveEndDate) : getTripLengthInDays(startDateAsDate, endDateAsDate);
    $[7] = adult_count;
    $[8] = childAges;
    $[9] = closest_city;
    $[10] = endDate;
    $[11] = isPopulated;
    $[12] = isTemplateTrip;
    $[13] = jfDuration;
    $[14] = room_count;
    $[15] = startDate;
    $[16] = effectiveEndDate;
    $[17] = effectiveStartDate;
    $[18] = startDateAsDate;
    $[19] = t10;
    $[20] = t11;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    effectiveEndDate = $[16];
    effectiveStartDate = $[17];
    startDateAsDate = $[18];
    t10 = $[19];
    t11 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  const t12 = isPopulated ? isTwinPreferred : false;
  let t13;
  if ($[30] !== effectiveEndDate || $[31] !== effectiveStartDate || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
    t13 = {
      adult_count: t6,
      child_count: t7,
      childAges: t8,
      room_count: t9,
      closest_city: t10,
      duration: t11,
      startDate: effectiveStartDate,
      endDate: effectiveEndDate,
      twinRoomPreferred: t12
    };
    $[30] = effectiveEndDate;
    $[31] = effectiveStartDate;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const initialValues = t13;
  let t14;
  let t15;
  if ($[40] !== setFormRef) {
    t14 = () => {
      if (formRef?.current) {
        setFormRef(formRef.current);
      }
    };
    t15 = [formRef, setFormRef];
    $[40] = setFormRef;
    $[41] = t14;
    $[42] = t15;
  } else {
    t14 = $[41];
    t15 = $[42];
  }
  useEffect(t14, t15);
  let t16;
  if ($[43] !== maxDurationDays || $[44] !== minDurationDays || $[45] !== t) {
    let t17;
    if ($[47] !== t) {
      t17 = (t18, schema) => {
        const [child_count] = t18;
        if (child_count > 0) {
          return schema.of(Yup.string().required(t("validation_child_ages"))).min(child_count, t("validation_child_ages"));
        }
        return schema;
      };
      $[47] = t;
      $[48] = t17;
    } else {
      t17 = $[48];
    }
    let t18;
    if ($[49] !== t) {
      t18 = (t19, schema_0) => {
        const [adult_count_0, childAges_0] = t19;
        const minRooms = minNumberRooms(adult_count_0, childAges_0);
        return schema_0.min(minRooms, t("validation_rooms_min", {
          count: minRooms
        }));
      };
      $[49] = t;
      $[50] = t18;
    } else {
      t18 = $[50];
    }
    t16 = Yup.object().shape({
      adult_count: Yup.number().min(1, t("validation_adults_required")).max(6, t("validation_adults_max")).required(t("validation_adults_required")),
      child_count: Yup.number().max(6, t("validation_children_max")),
      childAges: Yup.array().when(["child_count"], t17),
      room_count: Yup.number().max(6, t("validation_rooms_max")).required(t("validation_rooms_required")).when(["adult_count", "childAges"], t18),
      closest_city: Yup.string().required(t("validation_closest_city")),
      startDate: Yup.date().min(new Date(), t("validation_start_date_future")).nullable().required(t("validation_dates_required")),
      endDate: Yup.date().min(new Date(), t("validation_start_date_future")).nullable().required(t("validation_dates_required")),
      duration: Yup.number().min(minDurationDays, t("validation_duration_min", {
        count: minDurationDays
      })).max(maxDurationDays, t("validation_duration_max", {
        count: maxDurationDays
      })).required(t("validation_duration_required"))
    });
    $[43] = maxDurationDays;
    $[44] = minDurationDays;
    $[45] = t;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[51] !== featuredActivities || $[52] !== firstLegOriginId || $[53] !== initialValues || $[54] !== isUS || $[55] !== locale || $[56] !== origins || $[57] !== region || $[58] !== regionData.id || $[59] !== requestSource || $[60] !== router || $[61] !== setIsCheckingAvailability || $[62] !== startDateAsDate || $[63] !== uniqueId) {
    t17 = async (values, t18) => {
      const {
        setSubmitting
      } = t18;
      setIsCheckingAvailability(true);
      const findUpdatedKeys = _temp;
      const dateSlidingKeys = ["duration", "startDate", "endDate"];
      const nonDateKeyUpdated = findUpdatedKeys(values, initialValues).some(key_0 => !dateSlidingKeys.includes(key_0));
      const isSameStartDate = values.startDate ? isSameDay(startDateAsDate, values.startDate) : true;
      const isSameDuration = initialValues.duration === parseInt(values.duration, 10);
      const isDateSliding = !isSameStartDate && isSameDuration && !nonDateKeyUpdated;
      const newChildAges = values.childAges.slice(0, values.child_count);
      values.childAges = newChildAges;
      const childAgesAsNumbers = values.childAges.filter(_temp2);
      const originId = isUS ? firstLegOriginId : (origins ?? []).find(origin => origin.locationName === values.closest_city)?.id ?? getDefaultOriginId(locale);
      const response = await fetch("/api/merge-submission", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...values,
          uniqueId,
          childAges: childAgesAsNumbers,
          closest_city: originId,
          startDate: values.startDate ? formatDashedYYYYMMDD(values.startDate) : "",
          endDate: values.endDate ? formatDashedYYYYMMDD(values.endDate) : "",
          requestSource: buildRequestSource({
            environment: process.env.NEXT_PUBLIC_SOURCE_ENV,
            previous: requestSource,
            action: "edit"
          }),
          ...(featuredActivities && {
            featuredActivities
          }),
          ...(isDateSliding && {
            isDateSliding: true,
            newStartDate: values.startDate ? formatDashedYYYYMMDD(values.startDate) : "",
            previousJourneyId: uniqueId,
            previousRegionId: regionData.id
          }),
          useYearRoundPricingCache: false
        })
      });
      if (response.status !== 200) {
        setSubmitting(false);
        return;
      }
      const data = await response.json();
      const submissionId = data.content[0]?.submissionID;
      const isBypassEnabled = process.env.NEXT_PUBLIC_BYPASS_ENABLED === "true";
      if (submissionId) {
        const params = new URLSearchParams();
        region && params.set("region", region);
        isBypassEnabled && params.set("show", "1");
        const query = params.toString();
        const search = query ? `?${query}` : "";
        router.push(`/journey/${uniqueId}${search}`);
        router.refresh();
      }
    };
    $[51] = featuredActivities;
    $[52] = firstLegOriginId;
    $[53] = initialValues;
    $[54] = isUS;
    $[55] = locale;
    $[56] = origins;
    $[57] = region;
    $[58] = regionData.id;
    $[59] = requestSource;
    $[60] = router;
    $[61] = setIsCheckingAvailability;
    $[62] = startDateAsDate;
    $[63] = uniqueId;
    $[64] = t17;
  } else {
    t17 = $[64];
  }
  let t18;
  if ($[65] !== children || $[66] !== isOneWayTrip) {
    t18 = props => <Form>{children({
        ...props,
        isOneWayTrip,
        handleSubmit() {
          setIsTouched(true);
          props.handleSubmit();
        }
      } as any)}</Form>;
    $[65] = children;
    $[66] = isOneWayTrip;
    $[67] = t18;
  } else {
    t18 = $[67];
  }
  let t19;
  if ($[68] !== initialValues || $[69] !== isTouched || $[70] !== t16 || $[71] !== t17 || $[72] !== t18) {
    t19 = <Formik initialValues={initialValues} innerRef={formRef} enableReinitialize={true} validateOnBlur={isTouched} validateOnChange={isTouched} validationSchema={t16} onSubmit={t17}>{t18}</Formik>;
    $[68] = initialValues;
    $[69] = isTouched;
    $[70] = t16;
    $[71] = t17;
    $[72] = t18;
    $[73] = t19;
  } else {
    t19 = $[73];
  }
  return t19;
};
export { JourneyEditForm };
function _temp(values_0, initialValues_0) {
  return Object.entries(values_0).reduce((acc, t0) => {
    const [key, value] = t0;
    const isChildAges = key === "childAges";
    if (isChildAges && JSON.stringify(Array.isArray(value) ? [...value].sort() : []) !== JSON.stringify(Array.isArray(initialValues_0[key]) ? [...initialValues_0[key]].sort() : [])) {
      acc.push(key);
    } else {
      if (value !== initialValues_0[key] && !isChildAges) {
        acc.push(key);
      }
    }
    return acc;
  }, []);
}
function _temp2(age) {
  return !Number.isNaN(age);
}